import styled from 'styled-components'

const MainContainer = styled.button<{
  onClick: () => void
  type: string
}>`
  border: none;
  outline: none;
  height: 32px;
  width: 32px;
  background-color: transparent;
`
const Number = styled.div<{
  $isOnCurrentMonth: boolean
  $isInRange: boolean
}>`
  display: flex;
  height: 100%;
  width: 100%;
  font-family: inter;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.$isOnCurrentMonth ? '#292929' : '#B1B1B1')};
  transition: background-color 0.3s ease-out;
  &:hover {
    background-color: ${(props) =>
      props.$isOnCurrentMonth && !props.$isInRange ? '#e0e0e0' : ''};
  }
  cursor: ${(props) => (props.$isOnCurrentMonth ? 'pointer' : 'auto')};
  background-color: ${(props) =>
    props.$isInRange ? '#e0e0e0' : 'transparent'};

  &:hover {
    background-color: ${(props) =>
      props.$isOnCurrentMonth && !props.$isInRange ? '#e0e0e0' : ''};
  }
`

export { MainContainer, Number }
